// Role object for ShiftSupervisor with all true except ADMIN
export const ShiftSupervisor = {
  FLEX_SCHEDULER: {
    VIEW: true,
    REMOVE_WORKER: false,
    VIEW_AVAILABILITY: true,
    CREATE_SHIFT: true,
    MARK_ATTENDANCE: true,
    EDIT_DRAFT_SHIFT: true,
    EDIT_PUBLISHED_SHIFT: true,
    PUBLISH_SHIFT: true,
    DELETE_DRAFT_SHIFT: true,
    CANCEL_PUBLISHED_SHIFT: true,
    COPY_SHIFT: true,
    VIEW_SHIFT_DETAILS: true,
    BROADCAST_MESSAGE: true,
    RENOTIFY_WORKERS: true,
    MANUAL_ASSIGN_WORKERS: true,
  },
  CROSS_SKILLING: {
    VIEW: true,
    VIEW_SUMMARY: true,
    UPDATE_SKILL_LEVEL: true,
    ACCEPT_INTEREST: true,
  },
  JOBS_MATRIX: {
    VIEW: true,
    UPDATE_JOB_STATUS: true,
    VIEW_DETAILS: true,
  },
  WORKER_REQUESTS: {
    VIEW: true,
    REGULAR_SHIFT_REQUEST: true,
    OVERTIME_SHIFT_REQUEST: true,
    CREATE_COVERAGE_SHIFT: true,
    ACCEPT_REJECT_REGULAR_REQUEST: true,
    ACCEPT_REJECT_OVERTIME_REQUEST: true,
    EDIT_REGULAR_SHIFT_REQUEST: false,
    RAISE_WORKER_REQUEST: true,
  },
  REPORTS: {
    VIEW: true,
    VIEW_ATTENDANCE_REPORTS: true,
    MARK_ATTENDANCE: true,
    VIEW_SKILLS_SUMMARY_REPORTS: true,
    VIEW_ABSENCE_REPORTS: true,
    VIEW_MIN_WEEKLY_HOURS_HISTORY: true,
    UPDATE_LEAVE_BALANCE: false,
  },
  SETTINGS: {
    VIEW: true,
    VIEW_WORKERS: true,
    ADD_WORKERS: true,
    EDIT_WORKERS: true,
    DELETE_WORKERS: true,
    EDIT_WORKER_SKILLS_WITH_EVALUATION: false,
    VIEW_JOB_ROLES: true,
    ADD_JOB_ROLES: true,
    EDIT_JOB_ROLES: true,
    VIEW_SKILLS: true,
    ADD_SKILLS: true,
    EDIT_SKILLS: true,
    MARK_SKILL_OBSOLETE: true,
    VIEW_CERTIFICATIONS: true,
    ADD_CERTIFICATIONS: true,
    EDIT_CERTIFICATIONS: true,
    MARK_CERTIFICATION_OBSOLETE: true,
    VIEW_WORKCENTER: true,
    VIEW_USERS: false,
  },
  ADMIN: {
    VIEW: false,
  },
  FULL_TIME_SCHEDULER: {
    VIEW: true,
    VIEW_FULL_TIME_SHIFT_DETAILS: true,
    REASSIGN_WORKERS: true,
    CHANGE_STATUS: true,
    EDIT_DEMAND: true,
    GENERATE_SCHEDULE: false,
    EXPORT_SCHEDULE: true,
  },
};

// Role object for GATAdmin with all permissions set to true
export const GATAdmin = {
  FLEX_SCHEDULER: {
    VIEW: true,
    REMOVE_WORKER: true,
    VIEW_AVAILABILITY: true,
    CREATE_SHIFT: true,
    MARK_ATTENDANCE: true,
    EDIT_DRAFT_SHIFT: true,
    EDIT_PUBLISHED_SHIFT: true,
    PUBLISH_SHIFT: true,
    DELETE_DRAFT_SHIFT: true,
    CANCEL_PUBLISHED_SHIFT: true,
    COPY_SHIFT: true,
    VIEW_SHIFT_DETAILS: true,
    BROADCAST_MESSAGE: true,
    RENOTIFY_WORKERS: true,
    MANUAL_ASSIGN_WORKERS: true,
  },
  CROSS_SKILLING: {
    VIEW: true,
    VIEW_SUMMARY: true,
    UPDATE_SKILL_LEVEL: true,
    ACCEPT_INTEREST: true,
  },
  JOBS_MATRIX: {
    VIEW: true,
    UPDATE_JOB_STATUS: true,
    VIEW_DETAILS: true,
  },
  WORKER_REQUESTS: {
    VIEW: true,
    REGULAR_SHIFT_REQUEST: true,
    OVERTIME_SHIFT_REQUEST: true,
    CREATE_COVERAGE_SHIFT: true,
    ACCEPT_REJECT_REGULAR_REQUEST: true,
    ACCEPT_REJECT_OVERTIME_REQUEST: true,
    EDIT_REGULAR_SHIFT_REQUEST: true,
    RAISE_WORKER_REQUEST: true,
  },
  REPORTS: {
    VIEW: true,
    VIEW_ATTENDANCE_REPORTS: true,
    MARK_ATTENDANCE: true,
    VIEW_SKILLS_SUMMARY_REPORTS: true,
    VIEW_ABSENCE_REPORTS: true,
    VIEW_MIN_WEEKLY_HOURS_HISTORY: true,
    UPDATE_LEAVE_BALANCE: true,
  },
  SETTINGS: {
    VIEW: true,
    VIEW_WORKERS: true,
    ADD_WORKERS: true,
    EDIT_WORKERS: true,
    DELETE_WORKERS: true,
    EDIT_WORKER_SKILLS_WITH_EVALUATION: true,
    VIEW_JOB_ROLES: true,
    ADD_JOB_ROLES: true,
    EDIT_JOB_ROLES: true,
    VIEW_SKILLS: true,
    ADD_SKILLS: true,
    EDIT_SKILLS: true,
    MARK_SKILL_OBSOLETE: true,
    VIEW_CERTIFICATIONS: true,
    ADD_CERTIFICATIONS: true,
    EDIT_CERTIFICATIONS: true,
    MARK_CERTIFICATION_OBSOLETE: true,
    VIEW_WORKCENTER: true,
    VIEW_USERS: false,
  },
  ADMIN: {
    VIEW: true,
  },
  FULL_TIME_SCHEDULER: {
    VIEW: true,
    VIEW_FULL_TIME_SHIFT_DETAILS: true,
    REASSIGN_WORKERS: true,
    CHANGE_STATUS: true,
    EDIT_DEMAND: true,
    GENERATE_SCHEDULE: true,
  },
};

// Role object for ReadOnly with only view permissions
export const ReadOnly = {
  FLEX_SCHEDULER: {
    VIEW: true,
    REMOVE_WORKER: false,
    VIEW_AVAILABILITY: true,
    CREATE_SHIFT: true,
    MARK_ATTENDANCE: false,
    EDIT_DRAFT_SHIFT: false,
    EDIT_PUBLISHED_SHIFT: false,
    PUBLISH_SHIFT: false,
    DELETE_DRAFT_SHIFT: false,
    CANCEL_PUBLISHED_SHIFT: false,
    COPY_SHIFT: false,
    VIEW_SHIFT_DETAILS: true,
    BROADCAST_MESSAGE: false,
    RENOTIFY_WORKERS: false,
    MANUAL_ASSIGN_WORKERS: false,
  },
  CROSS_SKILLING: {
    VIEW: true,
    VIEW_SUMMARY: true,
    UPDATE_SKILL_LEVEL: false,
    ACCEPT_INTEREST: false,
  },
  JOBS_MATRIX: {
    VIEW: true,
    UPDATE_JOB_STATUS: false,
    VIEW_DETAILS: true,
  },
  WORKER_REQUESTS: {
    VIEW: true,
    REGULAR_SHIFT_REQUEST: false,
    OVERTIME_SHIFT_REQUEST: false,
    CREATE_COVERAGE_SHIFT: false,
    ACCEPT_REJECT_REGULAR_REQUEST: false,
    ACCEPT_REJECT_OVERTIME_REQUEST: false,
    EDIT_REGULAR_SHIFT_REQUEST: false,
    RAISE_WORKER_REQUEST: false,
  },
  REPORTS: {
    VIEW: true,
    VIEW_ATTENDANCE_REPORTS: true,
    MARK_ATTENDANCE: false,
    VIEW_SKILLS_SUMMARY_REPORTS: true,
    VIEW_ABSENCE_REPORTS: true,
    VIEW_MIN_WEEKLY_HOURS_HISTORY: true,
    UPDATE_LEAVE_BALANCE: false,
  },
  SETTINGS: {
    VIEW: true,
    VIEW_WORKERS: true,
    ADD_WORKERS: false,
    EDIT_WORKERS: false,
    DELETE_WORKERS: false,
    EDIT_WORKER_SKILLS_WITH_EVALUATION: false,
    VIEW_JOB_ROLES: true,
    ADD_JOB_ROLES: false,
    EDIT_JOB_ROLES: false,
    VIEW_SKILLS: true,
    ADD_SKILLS: false,
    EDIT_SKILLS: false,
    MARK_SKILL_OBSOLETE: false,
    VIEW_CERTIFICATIONS: true,
    ADD_CERTIFICATIONS: false,
    EDIT_CERTIFICATIONS: false,
    MARK_CERTIFICATION_OBSOLETE: false,
    VIEW_WORKCENTER: true,
    VIEW_USERS: false,
  },
  ADMIN: {
    VIEW: false,
  },
  FULL_TIME_SCHEDULER: {
    VIEW: true,
    VIEW_FULL_TIME_SHIFT_DETAILS: true,
    REASSIGN_WORKERS: false,
    CHANGE_STATUS: false,
    EDIT_DEMAND: false,
    GENERATE_SCHEDULE: false,
    EXPORT_SCHEDULE: false,
  },
};

// Role object for LimitedAccessSupervisor
export const LimitedAccessSupervisor = {
  FLEX_SCHEDULER: {
    VIEW: true,
    REMOVE_WORKER: false,
    VIEW_AVAILABILITY: true,
    CREATE_SHIFT: true,
    MARK_ATTENDANCE: true,
    EDIT_DRAFT_SHIFT: true,
    EDIT_PUBLISHED_SHIFT: true,
    PUBLISH_SHIFT: true,
    DELETE_DRAFT_SHIFT: true,
    CANCEL_PUBLISHED_SHIFT: true,
    COPY_SHIFT: true,
    VIEW_SHIFT_DETAILS: true,
    BROADCAST_MESSAGE: true,
    RENOTIFY_WORKERS: true,
    MANUAL_ASSIGN_WORKERS: true,
  },
  CROSS_SKILLING: {
    VIEW: true,
    VIEW_SUMMARY: true,
    UPDATE_SKILL_LEVEL: false,
    ACCEPT_INTEREST: false,
  },
  JOBS_MATRIX: {
    VIEW: true,
    UPDATE_JOB_STATUS: false,
    VIEW_DETAILS: true,
  },
  WORKER_REQUESTS: {
    VIEW: true,
    REGULAR_SHIFT_REQUEST: true,
    OVERTIME_SHIFT_REQUEST: true,
    CREATE_COVERAGE_SHIFT: true,
    ACCEPT_REJECT_REGULAR_REQUEST: true,
    ACCEPT_REJECT_OVERTIME_REQUEST: true,
    EDIT_REGULAR_SHIFT_REQUEST: false,
    RAISE_WORKER_REQUEST: true,
  },
  REPORTS: {
    VIEW: true,
    VIEW_ATTENDANCE_REPORTS: true,
    MARK_ATTENDANCE: true,
    VIEW_SKILLS_SUMMARY_REPORTS: true,
    VIEW_ABSENCE_REPORTS: true,
    VIEW_MIN_WEEKLY_HOURS_HISTORY: true,
    UPDATE_LEAVE_BALANCE: false,
  },
  SETTINGS: {
    VIEW: true,
    VIEW_WORKERS: true,
    ADD_WORKERS: false,
    EDIT_WORKERS: false,
    DELETE_WORKERS: false,
    EDIT_WORKER_SKILLS_WITH_EVALUATION: false,
    VIEW_JOB_ROLES: true,
    ADD_JOB_ROLES: false,
    EDIT_JOB_ROLES: false,
    VIEW_SKILLS: true,
    ADD_SKILLS: false,
    EDIT_SKILLS: false,
    MARK_SKILL_OBSOLETE: false,
    VIEW_CERTIFICATIONS: true,
    ADD_CERTIFICATIONS: false,
    EDIT_CERTIFICATIONS: false,
    MARK_CERTIFICATION_OBSOLETE: false,
    VIEW_WORKCENTER: true,
    VIEW_USERS: false,
  },
  ADMIN: {
    VIEW: false,
  },
  FULL_TIME_SCHEDULER: {
    VIEW: true,
    VIEW_FULL_TIME_SHIFT_DETAILS: true,
    REASSIGN_WORKERS: false,
    CHANGE_STATUS: false,
    EDIT_DEMAND: false,
    GENERATE_SCHEDULE: false,
    EXPORT_SCHEDULE: false,
  },
};

export const HRManager = {
  FLEX_SCHEDULER: {
    VIEW: true,
    REMOVE_WORKER: true,
    VIEW_AVAILABILITY: true,
    CREATE_SHIFT: true,
    MARK_ATTENDANCE: true,
    EDIT_DRAFT_SHIFT: true,
    EDIT_PUBLISHED_SHIFT: true,
    PUBLISH_SHIFT: true,
    DELETE_DRAFT_SHIFT: true,
    CANCEL_PUBLISHED_SHIFT: true,
    COPY_SHIFT: true,
    VIEW_SHIFT_DETAILS: true,
    BROADCAST_MESSAGE: true,
    RENOTIFY_WORKERS: true,
    MANUAL_ASSIGN_WORKERS: true,
  },
  CROSS_SKILLING: {
    VIEW: true,
    VIEW_SUMMARY: true,
    UPDATE_SKILL_LEVEL: true,
    ACCEPT_INTEREST: true,
  },
  JOBS_MATRIX: {
    VIEW: true,
    UPDATE_JOB_STATUS: true,
    VIEW_DETAILS: true,
  },
  WORKER_REQUESTS: {
    VIEW: true,
    REGULAR_SHIFT_REQUEST: true,
    OVERTIME_SHIFT_REQUEST: true,
    CREATE_COVERAGE_SHIFT: true,
    ACCEPT_REJECT_REGULAR_REQUEST: true,
    ACCEPT_REJECT_OVERTIME_REQUEST: true,
    EDIT_REGULAR_SHIFT_REQUEST: true,
    RAISE_WORKER_REQUEST: true,
  },
  REPORTS: {
    VIEW: true,
    VIEW_ATTENDANCE_REPORTS: true,
    MARK_ATTENDANCE: true,
    VIEW_SKILLS_SUMMARY_REPORTS: true,
    VIEW_ABSENCE_REPORTS: true,
    VIEW_MIN_WEEKLY_HOURS_HISTORY: true,
    UPDATE_LEAVE_BALANCE: false,
  },
  SETTINGS: {
    VIEW: true,
    VIEW_WORKERS: true,
    ADD_WORKERS: true,
    EDIT_WORKERS: true,
    DELETE_WORKERS: true,
    EDIT_WORKER_SKILLS_WITH_EVALUATION: true,
    VIEW_JOB_ROLES: true,
    ADD_JOB_ROLES: true,
    EDIT_JOB_ROLES: true,
    VIEW_SKILLS: true,
    ADD_SKILLS: true,
    EDIT_SKILLS: true,
    MARK_SKILL_OBSOLETE: true,
    VIEW_CERTIFICATIONS: true,
    ADD_CERTIFICATIONS: true,
    EDIT_CERTIFICATIONS: true,
    MARK_CERTIFICATION_OBSOLETE: true,
    VIEW_WORKCENTER: true,
    VIEW_USERS: true,
  },
  ADMIN: {
    VIEW: false,
  },
  FULL_TIME_SCHEDULER: {
    VIEW: true,
    VIEW_FULL_TIME_SHIFT_DETAILS: true,
    REASSIGN_WORKERS: true,
    CHANGE_STATUS: true,
    EDIT_DEMAND: true,
    GENERATE_SCHEDULE: true,
    EXPORT_SCHEDULE: true,
  },
};

export const DepartmentManager = {
  FLEX_SCHEDULER: {
    VIEW: true,
    REMOVE_WORKER: true,
    VIEW_AVAILABILITY: true,
    CREATE_SHIFT: true,
    MARK_ATTENDANCE: true,
    EDIT_DRAFT_SHIFT: true,
    EDIT_PUBLISHED_SHIFT: true,
    PUBLISH_SHIFT: true,
    DELETE_DRAFT_SHIFT: true,
    CANCEL_PUBLISHED_SHIFT: true,
    COPY_SHIFT: true,
    VIEW_SHIFT_DETAILS: true,
    BROADCAST_MESSAGE: true,
    RENOTIFY_WORKERS: true,
    MANUAL_ASSIGN_WORKERS: true,
  },
  CROSS_SKILLING: {
    VIEW: true,
    VIEW_SUMMARY: true,
    UPDATE_SKILL_LEVEL: true,
    ACCEPT_INTEREST: true,
  },
  JOBS_MATRIX: {
    VIEW: true,
    UPDATE_JOB_STATUS: true,
    VIEW_DETAILS: true,
  },
  WORKER_REQUESTS: {
    VIEW: true,
    REGULAR_SHIFT_REQUEST: true,
    OVERTIME_SHIFT_REQUEST: true,
    CREATE_COVERAGE_SHIFT: true,
    ACCEPT_REJECT_REGULAR_REQUEST: true,
    ACCEPT_REJECT_OVERTIME_REQUEST: true,
    EDIT_REGULAR_SHIFT_REQUEST: false,
    RAISE_WORKER_REQUEST: true,
  },
  REPORTS: {
    VIEW: true,
    VIEW_ATTENDANCE_REPORTS: true,
    MARK_ATTENDANCE: true,
    VIEW_SKILLS_SUMMARY_REPORTS: true,
    VIEW_ABSENCE_REPORTS: true,
    VIEW_MIN_WEEKLY_HOURS_HISTORY: true,
    UPDATE_LEAVE_BALANCE: false,
  },
  SETTINGS: {
    VIEW: true,
    VIEW_WORKERS: true,
    ADD_WORKERS: true,
    EDIT_WORKERS: true,
    DELETE_WORKERS: true,
    EDIT_WORKER_SKILLS_WITH_EVALUATION: false,
    VIEW_JOB_ROLES: true,
    ADD_JOB_ROLES: true,
    EDIT_JOB_ROLES: true,
    VIEW_SKILLS: true,
    ADD_SKILLS: true,
    EDIT_SKILLS: true,
    MARK_SKILL_OBSOLETE: true,
    VIEW_CERTIFICATIONS: true,
    ADD_CERTIFICATIONS: true,
    EDIT_CERTIFICATIONS: true,
    MARK_CERTIFICATION_OBSOLETE: true,
    VIEW_WORKCENTER: true,
    VIEW_USERS: false,
  },
  ADMIN: {
    VIEW: false,
  },
  FULL_TIME_SCHEDULER: {
    VIEW: true,
    VIEW_FULL_TIME_SHIFT_DETAILS: true,
    REASSIGN_WORKERS: true,
    CHANGE_STATUS: true,
    EDIT_DEMAND: true,
    GENERATE_SCHEDULE: false,
    EXPORT_SCHEDULE: true,
  },
};

// ---------------------------------------------------------------------------
// Evaluation feature RBAC — backed entirely by the permissions array returned
// by /Users/authenticate. Roles are not consulted: a permission string is
// either present (granted) or absent (denied). These constants are the
// canonical source of permission keys so call sites avoid magic strings.
// ---------------------------------------------------------------------------

export const EVALUATION_PERMISSIONS = {
  VIEW: "evaluation.view",
  WORKERS: {
    VIEW: "evaluation.workers.view",
    VIEW_PROGRAMS: "evaluation.workers.view_programs",
    START_EVALUATION: "evaluation.workers.start_evaluation",
    VIEW_PROGRAM_INSTANCE: "evaluation.workers.view_program_instance",
    INSTANCE: {
      // Eligibility/due date override on a single program instance
      // (POST /WorkerEvaluationInstance/UpdateInstanceDates). Granted to
      // GATAdmin, CompanyAdmin, HrManager and TrainingManager only — the
      // endpoint rejects every other role, so the entry point stays hidden
      // rather than failing on save.
      EDIT_DATES: "evaluation.workers.instance.edit_dates",
    },
    FORM: {
      FILL: "evaluation.workers.form.fill",
      VIEW: "evaluation.workers.form.view",
    },
    ADDITIONAL_FIELDS: {
      EDIT: "evaluation.workers.additional_fields.edit",
    },
  },
  MY_ACKNOWLEDGEMENTS: {
    VIEW: "evaluation.my_acknowledgements.view",
    OPEN: "evaluation.my_acknowledgements.open",
    SIGN: "evaluation.my_acknowledgements.sign",
  },
} as const;

export const EVALUATION_SETUP_PERMISSIONS = {
  VIEW: "settings.evaluation_setup.view",
  TEMPLATE: {
    VIEW: "settings.evaluation_setup.template.view",
    ADD: "settings.evaluation_setup.template.add",
    EDIT: "settings.evaluation_setup.template.edit",
    DELETE: "settings.evaluation_setup.template.delete",
    MANAGE_LOCATIONS: "settings.evaluation_setup.template.manage_locations",
  },
  CATEGORY: {
    MANAGE: "settings.evaluation_setup.category.manage",
    ADD: "settings.evaluation_setup.category.add",
    EDIT: "settings.evaluation_setup.category.edit",
    DELETE: "settings.evaluation_setup.category.delete",
  },
  ACKNOWLEDGEMENT: {
    VIEW: "settings.evaluation_setup.acknowledgement.view",
    ADD: "settings.evaluation_setup.acknowledgement.add",
    EDIT: "settings.evaluation_setup.acknowledgement.edit",
    DELETE: "settings.evaluation_setup.acknowledgement.delete",
  },
  PLAN: {
    VIEW: "settings.evaluation_setup.plan.view",
    ADD: "settings.evaluation_setup.plan.add",
    EDIT: "settings.evaluation_setup.plan.edit",
    DELETE: "settings.evaluation_setup.plan.delete",
    CHANGE_STATUS: "settings.evaluation_setup.plan.change_status",
    ASSIGN: "settings.evaluation_setup.plan.assign",
  },
} as const;

// ---------------------------------------------------------------------------
// Settings module RBAC (GAT-7216) — same dynamic model as the evaluation
// constants above: the strings below are matched against the permissions array
// from /Users/authenticate via hasPermissionString(). Evaluation Setup already
// has its own block (EVALUATION_SETUP_PERMISSIONS) and is not repeated here.
//
// Seeded by GAT-7725. Note that /Users/authenticate also returns an older flat
// set for the same module — "settings.view_workers", "settings.add_workers",
// "settings.mark_skill_obsolete" and so on — left over from the GAT-6608
// Phase 1 catalog. Both namespaces are live, so a gate written against either
// one appears to work. Use these dotted codes: the flat set has no code for
// export, worker profile, skill level requirements, any user action beyond
// view, or leave balance, and it carries entries its own catalog tags
// "[Phase 0 generic — retire in Phase 2]".
//
// The Reports module keeps its own leave-balance report key; the keys below
// cover only the editable Leave Balance screen that hangs off Settings.
// ---------------------------------------------------------------------------

export const SETTINGS_PERMISSIONS = {
  VIEW: "settings.view",
  WORKERS: {
    VIEW: "settings.workers.view",
    ADD: "settings.workers.add",
    // Gates every edit affordance on the worker record: details, job roles,
    // skills and certifications tabs. A 1:1 replacement for the legacy
    // SETTINGS.EDIT_WORKERS key, which gated all four the same way.
    EDIT: "settings.workers.edit",
    DELETE: "settings.workers.delete",
    EXPORT: "settings.workers.export",
    // Opens the worker profile drawer (karma, reliability and consistency
    // scores). Flag-gated on showWorkerProfile today, with no permission.
    VIEW_PROFILE: "settings.workers.view_profile",
    // Lets the holder set a worker's skill level directly instead of going
    // through an evaluation form, when skill evaluation is enabled.
    EDIT_SKILLS_WITH_EVALUATION: "settings.workers.edit_skills_with_evaluation",
  },
  JOB_ROLES: {
    VIEW: "settings.job_roles.view",
    ADD: "settings.job_roles.add",
    EDIT: "settings.job_roles.edit",
  },
  SKILLS: {
    VIEW: "settings.skills.view",
    ADD: "settings.skills.add",
    EDIT: "settings.skills.edit",
    // Covers both directions of the toggle — mark obsolete and re-activate.
    MARK_OBSOLETE: "settings.skills.mark_obsolete",
    // Per-level requirement editor inside the skill dialog. Flag-gated on
    // isSkillLevelRequirementsEnabled today, with no permission.
    MANAGE_LEVEL_REQUIREMENTS: "settings.skills.manage_level_requirements",
  },
  CERTIFICATIONS: {
    VIEW: "settings.certifications.view",
    ADD: "settings.certifications.add",
    EDIT: "settings.certifications.edit",
    MARK_OBSOLETE: "settings.certifications.mark_obsolete",
  },
  WORKCENTERS: {
    // Work Centers is a read-only screen today, so view is the only key.
    VIEW: "settings.workcenters.view",
  },
  USERS: {
    // Replaces the roles.includes("HR Manager") check that used to decide
    // whether the Users entry appeared in the Settings submenu.
    VIEW: "settings.users.view",
    ADD: "settings.users.add",
    EDIT: "settings.users.edit",
    // Activate / deactivate a user. There is no hard delete on this screen.
    CHANGE_STATUS: "settings.users.change_status",
    // Act on a user who holds the HR Manager role. Restricted to GATAdmin
    // today by a hard-coded role check in use-supervisor-columns.tsx.
    MANAGE_HR_MANAGER: "settings.users.manage_hr_manager",
  },
  LEAVE_BALANCE: {
    VIEW: "settings.leave_balance.view",
    // Drives the editable balance grid; without it the screen is the
    // read-only report. Replaces REPORTS.UPDATE_LEAVE_BALANCE here only.
    EDIT: "settings.leave_balance.edit",
  },
} as const;

// ---------------------------------------------------------------------------
// Cross Skilling module RBAC (GAT-7253, GAT-7254) — same dynamic model as the
// blocks above, matched via hasPermissionString(). Unlike Settings these codes
// are flat module.action, which is how the backend seeds this module.
//
// The SkillsMatrix/* endpoints behind the Skills Matrix tab also serve Manage
// Workers, Jobs Matrix and Evaluation Setup, so the backend accepts any of
// several module view codes there. On the frontend VIEW gates only the Skills
// Matrix tab itself; the other pages keep their own gates.
// ---------------------------------------------------------------------------

export const CROSS_SKILLING_PERMISSIONS = {
  VIEW: "cross_skilling.view",
  // Summary tab and the Skill Summary report under Reports.
  VIEW_SUMMARY: "cross_skilling.view_summary",
  // Set a worker's level from a Skills Matrix cell (PUT workers/SkillLevel).
  UPDATE_SKILL_LEVEL: "cross_skilling.update_skill_level",
  // Approve a worker's skill interest (PUT workers/SkillInterest/{id}), from
  // the matrix or from the worker's Skills tab in Settings.
  ACCEPT_INTEREST: "cross_skilling.accept_interest",
  // Add, edit or remove a worker's skill directly (workers/skill). Only the
  // worker's Skills tab in Settings does this; the matrix sets levels instead.
  MANAGE_WORKER_SKILLS: "cross_skilling.manage_worker_skills",
  // "View log" in a matrix cell's menu (GET WorkerSkill/audit-log). Narrower
  // than UPDATE_SKILL_LEVEL: HR Manager can set levels but not read the log.
  VIEW_AUDIT_LOG: "cross_skilling.view_audit_log",
} as const;

// ---------------------------------------------------------------------------
// Flex Scheduler RBAC (GAT-7251) — dynamic permission strings from the login
// response or /Users/Permissions, matched with hasPermissionString(). Replaces the legacy
// FLEX_SCHEDULER.* lookups against the hard-coded role objects at the top of
// this file, and the userRoles.includes("ReadOnly") checks that stood in for a
// permission on the shift details dialog and the broadcast button.
//
// flex_scheduler is not on the policy-based RBAC system yet (GAT-6608 Phase
// 2), so these codes gate the UI only: the server does not check them.
//
// VIEW is defined here for completeness but is deliberately not wired to the
// drawer entry or the /flex-schedule and /shift routes yet: the flex scheduler
// is still the fallback landing page ("/" renders it whenever
// supervisorDashboardEnabled is off), so gating it needs a landing-page
// fallback first. Wiring VIEW without that would strand a user on a blank "/".
// ---------------------------------------------------------------------------

export const FLEX_SCHEDULER_PERMISSIONS = {
  VIEW: "flex_scheduler.view",
  // Availability tab next to Shifts in the scheduler page header. Ungated
  // before this change.
  VIEW_AVAILABILITY: "flex_scheduler.view_availability",
  CREATE_SHIFT: "flex_scheduler.create_shift",
  MARK_ATTENDANCE: "flex_scheduler.mark_attendance",
  EDIT_DRAFT_SHIFT: "flex_scheduler.edit_draft_shift",
  EDIT_PUBLISHED_SHIFT: "flex_scheduler.edit_published_shift",
  PUBLISH_SHIFT: "flex_scheduler.publish_shift",
  DELETE_DRAFT_SHIFT: "flex_scheduler.delete_draft_shift",
  CANCEL_PUBLISHED_SHIFT: "flex_scheduler.cancel_published_shift",
  COPY_SHIFT: "flex_scheduler.copy_shift",
  // Opens the shift details dialog from the calendar tooltip. Ungated before
  // this change.
  VIEW_SHIFT_DETAILS: "flex_scheduler.view_shift_details",
  BROADCAST_MESSAGE: "flex_scheduler.broadcast_message",
  RENOTIFY_WORKERS: "flex_scheduler.renotify_workers",
  // Covers the whole force/manual assignment flow: the shortfall notice, the
  // worker preferences step, row selection on the assign table and the
  // confirm button.
  MANUAL_ASSIGN_WORKERS: "flex_scheduler.manual_assign_workers",
  REMOVE_WORKER: "flex_scheduler.remove_worker",
  // Pick specific Workers for a draft Shift as part of publishing it, or for
  // the Shift a coverage approval creates. Allowed only at the locations listed
  // for it in permissionLocations (see use-can-direct-assign.ts).
  DIRECT_ASSIGN_WORKERS: "flex_scheduler.direct_assign_workers",
} as const;


// ---------------------------------------------------------------------------
// Worker Requests: past-dated time off (GAT-7829). The backend decides who may
// go back how far, per location, and sends it in GET /Users/Permissions under
// permissionSettings. The server enforces the same limit on submit.
// ---------------------------------------------------------------------------

export const WORKER_REQUESTS_PERMISSIONS = {
  // Add time off on a worker's behalf for a date that has already passed.
  CREATE_PAST_TIME_OFF: "worker_requests.create_past_time_off",
} as const;

export const PERMISSION_SETTINGS = {
  // How many days back; comes with earliestAllowedDate per location.
  LOOKBACK_DAYS: "lookback_days",
} as const;

// ---------------------------------------------------------------------------
// Jobs Matrix dynamic RBAC (GAT-7255). Replaces the legacy JOBS_MATRIX.* keys
// and the ReadOnly role check in the job cell.
//
// The seed also carries jobs_matrix.view_jobs, .view_matrix and
// .update_worker_jobs. Those are Phase 0 codes marked for retirement and
// granted to GATAdmin only, so they are deliberately not used here.
// ---------------------------------------------------------------------------

export const JOBS_MATRIX_PERMISSIONS = {
  // Jobs Matrix tab and, through it, the Cross Skilling drawer entry.
  VIEW: "jobs_matrix.view",
  // Set or remove a worker's job from a matrix cell.
  UPDATE_JOB_STATUS: "jobs_matrix.update_job_status",
  // "View details" in a matrix cell's menu (worker job audit log).
  VIEW_DETAILS: "jobs_matrix.view_details",
} as const;

// ---------------------------------------------------------------------------
// Full Time (Advanced) Scheduler dynamic RBAC (GAT-7252). Replaces the legacy
// FULL_TIME_SCHEDULER.* keys. Every gate below still sits on top of the
// company and location flags that turn the scheduler on.
// ---------------------------------------------------------------------------

export const FULL_TIME_SCHEDULER_PERMISSIONS = {
  // Advanced Schedule drawer entry and the /full-time-schedule route.
  VIEW: "full_time_scheduler.view",
  // Open a shift from the weekly view.
  VIEW_FULL_TIME_SHIFT_DETAILS: "full_time_scheduler.view_full_time_shift_details",
  // Move workers between jobs in the shift dialog, add a worker to an
  // understaffed job, and save those moves.
  REASSIGN_WORKERS: "full_time_scheduler.reassign_workers",
  // The status chip on each worker in the shift dialog and on the Workers
  // tab cards (Training, Restricted Duty, Called Off, ...). Shared
  // REASSIGN_WORKERS under the legacy map.
  CHANGE_STATUS: "full_time_scheduler.change_status",
  // The Demand button in the Shifts toolbar and the demand inputs behind it.
  EDIT_DEMAND: "full_time_scheduler.edit_demand",
  GENERATE_SCHEDULE: "full_time_scheduler.generate_schedule",
  EXPORT_SCHEDULE: "full_time_scheduler.export_schedule",
} as const;
